import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerCardNumber } from 'src/app/shared/models/customer.model';
import { AlertService } from 'src/app/core/alert.service';
import { AuthService } from 'src/app/core/auth.service';
import { CustomerManagementService } from 'src/app/shared/services/customer.service';

@Component({
  selector: 'app-card-update-form',
  templateUrl: './card-update-form.component.html',
  styleUrls: ['./card-update-form.component.scss']
})
export class CardUpdateFormComponent implements OnInit {
  @Input() card: CustomerCardNumber;
  @Input() customerId: number;
  @Input() locationId: number;

  isSubmitted: boolean = false;
  isProcessing: boolean = false;
  cardExpiry: string = '';

  constructor(
    private modalRef: NgbActiveModal,
    private authService: AuthService,
    private alertService: AlertService,
    private customerService: CustomerManagementService,
  ) { }

  ngOnInit(): void {
    this.cardExpiry = this.card.ExpMonth + '/' + this.card.ExpYear;
  }

  onClose(data?: any) {
    this.modalRef.close(data);
  }

  onKeyup(e: any): void {
    if (e.code === 'Backspace') return

    this.cardExpiry = e.target.value.replace(
      /^([1-9]\/|[2-9])$/g, '0$1/' // 3 > 03/
    ).replace(
      /^(0[1-9]|1[0-2])$/g, '$1/' // 11 > 11/
    ).replace(
      /^([0-1])([3-9])$/g, '0$1/$2' // 13 > 01/3
    ).replace(
      /^(0?[1-9]|1[0-2])([0-9]{4})$/g, '$1/$2' // 141 > 01/41
    ).replace(
      /^([0]+)\/|[0]+$/g, '0' // 0/ > 0 and 00 > 0
    );
  }

  onKeydown(e: any): void {
    if (e.code === 'Slash') {
      e.preventDefault();
      return;
    }
  }

  onSaveCard(): void {
    this.isProcessing = true;

    const expiryMonth = Number.parseInt(this.cardExpiry.split('/')[0]);
    const expiryYear = Number.parseInt(this.cardExpiry.split('/')[1]);

    const payload = {
      customerId: this.customerId,
      locationId: this.locationId,
      cardInfo: {
        expMonth: expiryMonth,
        expYear: expiryYear,
        cardLast4Digits: this.card.CardLast4Digits,
        token: this.card.Token,
        cardType: this.card.CardBrand,
      },
    };

    this.customerService
      .updateCardToken(payload)
      .subscribe({
        next: (res) => {
          if (res.toLowerCase() === 'successfully updated the token.') {
            this.setDefaultCard(expiryMonth, expiryYear);
          } else {
            this.alertService.alertError({
              title: 'Error',
              text: res,
            });
            this.isProcessing = false;
          }
        },
        error: (err) => {
          this.alertService.alertError({
            title: 'Error',
            text: err.error,
          });
          this.isProcessing = false;
        },
      })
  }

  setDefaultCard(expMonth: number, expYear: number): void {
    this.card.UpdatedBy = Number.parseInt(JSON.parse(this.authService.getUserInfo()).UserId);
    this.card.UpdatedDate = new Date();
    this.card.ExpMonth = expMonth;
    this.card.ExpYear = expYear;

    this.customerService
      .updateCustomerCardNumber(this.card)
      .subscribe({
        next: () => {
          this.alertService.alertSuccess({
            title: 'Success!',
            text: 'Successfully updated card details',
          });
          this.onClose(true);
        },
        error: (error) => {
          this.alertService.alertError({
            title: 'Error',
            text: error.error,
          });
          this.isProcessing = false;
        },
      })
  }
}
